// SacBotAnacapri.js
(function () {
  const LCW_SCRIPT_ID = "Microsoft_Omnichannel_LCWidget";

  const APP_ID =
    "636c577f-c98a-4a80-9bf9-07cd1c0c894d";

  const ORG_ID =
    "b606a206-e1ad-f011-8706-000d3ac0a3e4";

  const ORG_URL =
    "https://m-b606a206-e1ad-f011-8706-000d3ac0a3e4.br.omnichannelengagementhub.com";

  const PRIMARY_SCRIPT_URL =
    "https://oc-cdn-public-sam.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js";

  const FALLBACK_SCRIPT_URL =
    "https://ocprodpublicsamgs.blob.core.windows.net/livechatwidget/scripts/LiveChatBootstrapper.js";

  let initialized = false;

  /**
   * Elimina cualquier elemento o estilo residual
   * de la implementación anterior.
   */
  function removeLegacyCustomization() {
    const legacyLauncher =
      document.getElementById(
        "anacapri-omni-launcher"
      );

    if (legacyLauncher) {
      legacyLauncher.remove();
    }

    const legacyStyles =
      document.getElementById(
        "anacapri-omni-styles"
      );

    if (legacyStyles) {
      legacyStyles.remove();
    }

    document.body.classList.remove(
      "anacapri-chat-open"
    );
  }

  /**
   * Identifica si un iframe pertenece al widget.
   */
  function isOmnichannelFrame(element) {
    if (
      !element ||
      element.tagName !== "IFRAME"
    ) {
      return false;
    }

    const id =
      element.id || "";

    const src =
      element.getAttribute("src") || "";

    const title =
      element.getAttribute("title") || "";

    return (
      id.includes("Microsoft_Omnichannel") ||
      id.toLowerCase().includes("lcw") ||
      src.includes("livechatwidget") ||
      src.includes("omnichannel") ||
      title.toLowerCase().includes("chat")
    );
  }

  /**
   * Retira el foco del iframe después de minimizar.
   *
   * No modifica tamaño, posición, visibilidad ni
   * pointer-events, porque esas propiedades deben
   * quedar bajo control del Modern UI.
   */
  function releaseWidgetFocus() {
    const activeElement =
      document.activeElement;

    if (
      isOmnichannelFrame(activeElement) &&
      typeof activeElement.blur === "function"
    ) {
      activeElement.blur();
    }
  }

  /**
   * Configura únicamente los parámetros oficiales
   * necesarios para cargar el widget.
   */
  function configureWidgetScript(script) {
    script.async = true;

    script.setAttribute(
      "data-app-id",
      APP_ID
    );

    script.setAttribute(
      "data-lcw-version",
      "prod"
    );

    script.setAttribute(
      "data-org-id",
      ORG_ID
    );

    script.setAttribute(
      "data-org-url",
      ORG_URL
    );

    script.setAttribute(
      "data-open-in-window",
      "false"
    );

    script.setAttribute(
      "data-font-family-override",
      "var(--font-body-family, Arial, Segoe UI, sans-serif)"
    );

    /*
     * IMPORTANTE:
     *
     * No se agrega data-hide-chat-button.
     * Esto permite mostrar el botón nativo
     * correspondiente al Modern UI.
     *
     * Tampoco se agrega data-hide-minimize-button.
     * Microsoft controlará el botón de minimizar.
     */
  }

  /**
   * Carga el script fallback si falla el CDN principal.
   */
  function loadFallbackScript() {
    const existingScript =
      document.getElementById(
        LCW_SCRIPT_ID
      );

    if (existingScript) {
      existingScript.remove();
    }

    const fallback =
      document.createElement("script");

    fallback.id =
      LCW_SCRIPT_ID;

    fallback.src =
      FALLBACK_SCRIPT_URL;

    configureWidgetScript(
      fallback
    );

    fallback.onerror = function () {
      console.error(
        "No fue posible cargar el widget de Microsoft Omnichannel."
      );
    };

    document.body.appendChild(
      fallback
    );
  }

  /**
   * Carga el widget de Omnichannel.
   */
  function loadOmnichannelWidget() {
    const existingScript =
      document.getElementById(
        LCW_SCRIPT_ID
      );

    if (existingScript) {
      return;
    }

    const script =
      document.createElement("script");

    script.id =
      LCW_SCRIPT_ID;

    script.src =
      PRIMARY_SCRIPT_URL;

    configureWidgetScript(
      script
    );

    script.onerror = function () {
      console.warn(
        "Falló el CDN principal de Omnichannel. Intentando fallback."
      );

      loadFallbackScript();
    };

    document.body.appendChild(
      script
    );
  }

  /**
   * Escucha solamente eventos informativos.
   *
   * No cambia clases, tamaños ni estilos del iframe.
   */
  function bindOmnichannelEvents() {
    window.addEventListener(
      "lcw:ready",
      function () {
        console.info(
          "Microsoft Omnichannel Modern UI cargado correctamente."
        );
      }
    );

    window.addEventListener(
      "lcw:onMinimize",
      function () {
        requestAnimationFrame(
          releaseWidgetFocus
        );
      }
    );

    window.addEventListener(
      "lcw:onClose",
      function () {
        requestAnimationFrame(
          releaseWidgetFocus
        );
      }
    );

    window.addEventListener(
      "lcw:closeChat",
      function () {
        requestAnimationFrame(
          releaseWidgetFocus
        );
      }
    );
  }

  /**
   * Inicialización.
   */
  function start() {
    if (initialized) {
      return;
    }

    initialized = true;

    removeLegacyCustomization();
    bindOmnichannelEvents();
    loadOmnichannelWidget();
  }

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();